import { useState } from "react";
import { Drawer, Box, IconButton } from "@mui/material";
import SidebarLinks from "./SidebarLinks";
import LogoIcon from "assets/icons/red-logo.svg";
import BurgerMenuIcon from "assets/icons/burMenu.svg";
import { useTranslation } from "react-i18next";

/**
 * Provides navigation functionality
 */
const Sidebar = () => {
  const [isExpanded, setIsExpanded] = useState(false); //for the mouse hover
  const [isLocked, setIsLocked] = useState(false); //for the menu lock

  const toggleLock = () => setIsLocked((prev) => !prev);

  const { i18n } = useTranslation();

  return (
    <Drawer
      variant="permanent"
      onMouseEnter={() => !isLocked && setIsExpanded(true)}
      onMouseLeave={() => !isLocked && setIsExpanded(false)}
      sx={{
        width: isExpanded ? 280 : 80,
        transition: "width 0.3s",
        "& .MuiDrawer-paper": {
          width: isExpanded ? 280 : 80,
          overflow: "hidden",
          backgroundColor: "background.dark",
          color: "#fff",
          transition: "width 0.3s",
          position: "absolute", // make the sidebar dynamic for translate
          [i18n.language === "ar" ? "right" : "left"]: 0,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isExpanded ? "space-between" : "center",
          padding: "1rem",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <img
            src={LogoIcon}
            alt="Logo"
            style={{ width: "45px", height: "45px" }}
          />
        </Box>

        {isExpanded && (
          <IconButton
            onClick={toggleLock}
            sx={{
              color: "#fff",
              border: "1px solid white",
              borderRadius: "4px",
            }}
          >
            <img src={BurgerMenuIcon} alt="Menu" style={{ width: "24px" }} />
          </IconButton>
        )}
      </Box>

      <SidebarLinks isExpanded={isExpanded} />
    </Drawer>
  );
};

export default Sidebar;
